import React, { ReactNode } from 'react';
import './CardContainer.css';
export interface IBorderSettings {
    display?: boolean;
    squareBorder?: boolean;
    borderRadiusMedium?: boolean;
    borderColor?: string; 
} 

export interface ICardContainerProps extends React.HTMLAttributes<HTMLDivElement> {
    className?: string;
    addDropShadow?: boolean;
    borderSettings?: IBorderSettings;
    bgColor? : 'white' | 'grey-lightest' | 'purple' | 'blue-creditone' | 'none';
    children?: ReactNode;
}

const CardContainer = ({
    className = '', 
    addDropShadow = false,
    borderSettings = {},
    bgColor = 'white',
    children, 
    ...rest }: ICardContainerProps) => {
    const {display = true , squareBorder = false, borderRadiusMedium = false, borderColor = 'grey-80'} = borderSettings;

    const backgroundColor = `bg-${bgColor}`
    const formattedClassName = `${squareBorder ? 'CardContainer__squareBorder' : ''} ${!display? 'border-none' : 'border-solid'} ${borderRadiusMedium ? 'CardContainer__mediumRadiusBorder' : ''} border-${borderColor}`

    return (
        <div className={`CardContainer ${className} ${backgroundColor} ${formattedClassName} ${addDropShadow ? 'CardContainer__dropshadow' : ''}`} {...rest}>
            {children}
        </div>
    );
};


export default CardContainer;